module.exports = __webpack_public_path__ + "modules/home/images/about-4.png?2a915130";


//////////////////
// WEBPACK FOOTER
// ./modules/home/images/about-4.png
// module id = 92
// module chunks = 0